/* unplugin-vue-components disabled */import script from "./MaterialCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialCategory.vue?vue&type=script&setup=true&lang=js"

import "./MaterialCategory.vue?vue&type=style&index=0&id=95679b24&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95679b24"]])

export default __exports__